import { render, staticRenderFns } from "./Idioms.vue?vue&type=template&id=e995b8da&scoped=true&"
import script from "./Idioms.vue?vue&type=script&lang=js&"
export * from "./Idioms.vue?vue&type=script&lang=js&"
import style0 from "./Idioms.vue?vue&type=style&index=0&id=e995b8da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e995b8da",
  null
  
)

export default component.exports